function ClickIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6.815 11.42a2.65 2.65 0 01-.934-.618 2.765 2.765 0 010-3.906 2.765 2.765 0 014.466.804l1.264.416A3.781 3.781 0 0010.55 6.12a3.848 3.848 0 00-5.429 0 3.848 3.848 0 000 5.429 3.89 3.89 0 002.097 1.077l-.402-1.207z" />
      <path d="M17.341 11.175L7.95 8.045a.648.648 0 00-.675.158.655.655 0 00-.158.675l3.131 9.392c.158.473.804.502 1.02.057l1.91-3.978a.563.563 0 01.258-.258l3.978-1.91c.43-.202.388-.848-.072-1.006z" />
    </svg>
  )
}

export default ClickIcon
